// extracted by mini-css-extract-plugin
module.exports = {"root":"Calendar_root__2ChPt"};